module.exports = __webpack_public_path__ + "img/vv2.f95f9f0b.jpg";